import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeleteDailyDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteDailyDialog: React.FC<DeleteDailyDialogProps> = ({
  open,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Daily Habit"
      message="Are you sure you want to delete this daily habit?"
      confirmLabel="Delete"
      severity="error"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteDailyDialog;
